// Leave & Attendance Requests: its lists that open by address. No React in here. (The
// dashboard's key, its address and the names in this file still say Approvals; no words
// a person reads call it that.)
//
// Requests are decided on another page, My Approvals, which the dashboard offers under
// "Related" (navigation/catalog) to someone who holds it.
import type { DashboardListInfo } from './types';

/** The four views of the month's requests. Each slug is also the status the list opens on. */
export const APPROVALS_LIST = { all: 'all', pending: 'pending', approved: 'approved', rejected: 'rejected' } as const;
export type ApprovalsListSlug = (typeof APPROVALS_LIST)[keyof typeof APPROVALS_LIST];

export const approvalsListFromSlug = (slug: string | null): ApprovalsListSlug | null =>
  (Object.values(APPROVALS_LIST) as string[]).includes(slug ?? '') ? (slug as ApprovalsListSlug) : null;

export const LISTS: DashboardListInfo[] = [
  { slug: APPROVALS_LIST.pending, name: 'Pending', line: 'Requests raised in the month that are still waiting for a decision, longest wait first.', keywords: 'waiting undecided leave regularization correction' },
  { slug: APPROVALS_LIST.all, name: 'Requests raised', line: 'Every leave and attendance-correction request raised in the month.' },
  { slug: APPROVALS_LIST.approved, name: 'Approved', line: 'Requests raised in the month that were approved.' },
  { slug: APPROVALS_LIST.rejected, name: 'Rejected', line: 'Requests raised in the month that were rejected.' },
];
